// TODO download modules ///////////////////////////////////////////////////////////////////////////////////////////////
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// TODO custom modules /////////////////////////////////////////////////////////////////////////////////////////////////
import * as components from "../../js/components";
import * as constants from "../../js/constants";
import * as utils from "../../js/utils";
// TODO default export const page //////////////////////////////////////////////////////////////////////////////////////
export const SalaryPage = () => {
  // TODO react hooks variables ////////////////////////////////////////////////////////////////////////////////////////
  const dispatch = useDispatch();
  // TODO custom variables /////////////////////////////////////////////////////////////////////////////////////////////
  const [month, monthSet] = useState(
    utils.GetCurrentDay(false) < 10
      ? utils.GetCurrentMonth(false, -2)
      : utils.GetCurrentMonth(false, -1)
  );
  const [year, yearSet] = useState(
    utils.GetCurrentMonth(false, 0) == 1 ||
    (utils.GetCurrentMonth(false, 0) == 2 && utils.GetCurrentDay(false) < 10)
      ? utils.GetCurrentYear(-1)
      : utils.GetCurrentYear(0)
  );
  // TODO react store variables ////////////////////////////////////////////////////////////////////////////////////////
  const salaryUserStore = useSelector((state) => state.salaryUserStore);
  const {
    load: loadSalaryUser,
    data: dataSalaryUser,
  } = salaryUserStore;
  // TODO handlers /////////////////////////////////////////////////////////////////////////////////////////////////////
  const handlerSubmit = async (e) => {
    try { e.preventDefault(); } catch (error) {}
    const form = {
      "Action-type": "USER_SALARY",
      dateTime: `${year}${month > 9 ? month : "0" + month}`,
    };
    dispatch(
      utils.ActionConstructorUtility(
        form, "/api/auth/user/salary/", "POST", 30000,
        constants.USER_SALARY, true
      )
    );
  };

  const months = [
    "Январь","Февраль","Март","Апрель","Май","Июнь",
    "Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"
  ];
  const years = [2022,2023,2024,2025,2026,2027,2028,2029,2030];

  // TODO return page //////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="m-0 p-0">
      <components.HeaderComponent />
      <main>
        <div style={{ padding: "28px 32px 32px" }}>

          {/* ===== ФОРМА ВЫБОРА ПЕРИОДА ===== */}
          <div className="custom-card m-0 p-0 mb-4" style={{ maxWidth: 560 }}>
            <div style={{
              padding: "16px 20px",
              borderBottom: "1px solid var(--km-line)",
              display: "flex", alignItems: "center", gap: 10
            }}>
              <i className="fa-solid fa-file-invoice-dollar" style={{ color: "var(--km-blue)", fontSize: 18 }} />
              <span style={{ fontWeight: 700, fontSize: 15 }}>Расчётный лист</span>
            </div>
            <div style={{ padding: "20px" }}>
              <p style={{ fontSize: 13, color: "var(--km-text-soft)", margin: "0 0 16px" }}>
                Выберите месяц и год, затем нажмите «Получить»
              </p>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <div style={{ flex: "1 1 160px" }}>
                  <label style={{ fontSize: 11.5, fontWeight: 600, color: "var(--km-text-soft)", display: "block", marginBottom: 5 }}>
                    Месяц
                  </label>
                  <select
                    className="form-control form-control-sm"
                    value={month}
                    required
                    onChange={(e) => monthSet(e.target.value)}
                    style={{ borderRadius: 8, height: 40, fontSize: 14, paddingLeft: 10 }}
                  >
                    {months.map((m, i) => (
                      <option key={i} value={i + 1}>{m}</option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: "1 1 100px" }}>
                  <label style={{ fontSize: 11.5, fontWeight: 600, color: "var(--km-text-soft)", display: "block", marginBottom: 5 }}>
                    Год
                  </label>
                  <select
                    className="form-control form-control-sm"
                    value={year}
                    required
                    onChange={(e) => yearSet(e.target.value)}
                    style={{ borderRadius: 8, height: 40, fontSize: 14, paddingLeft: 10 }}
                  >
                    {years.map((y) => (
                      <option key={y} value={y}>{y}</option>
                    ))}
                  </select>
                </div>
                <div style={{ flex: "0 0 auto", alignSelf: "flex-end" }}>
                  {!loadSalaryUser && (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handlerSubmit}
                      style={{ height: 40, fontWeight: 600, borderRadius: 8, paddingLeft: 18, paddingRight: 18 }}
                    >
                      <i className="fa-solid fa-circle-check m-0 p-1" />
                      Получить
                    </button>
                  )}
                  {loadSalaryUser && (
                    <button className="btn btn-primary" disabled style={{ height: 40, borderRadius: 8, paddingLeft: 18, paddingRight: 18 }}>
                      <span className="spinner-border spinner-border-sm m-0 me-2" />
                      Загрузка...
                    </button>
                  )}
                </div>
              </div>
              <div style={{
                marginTop: 14, padding: "9px 12px", background: "#FBEAEA",
                borderRadius: 8, display: "flex", alignItems: "flex-start", gap: 8, fontSize: 12.5,
                color: "var(--km-danger)"
              }}>
                <i className="fa-solid fa-circle-exclamation" style={{ marginTop: 2, flexShrink: 0 }} />
                Если после ожидания данных нет — попробуйте ещё 1–2 раза или подождите полчаса.
              </div>
            </div>
          </div>

          {/* ===== РЕЗУЛЬТАТ ===== */}
          <components.StoreStatusComponent
            storeStatus={salaryUserStore}
            keyStatus={"salaryUserStore"}
            consoleLog={constants.DEBUG_CONSTANT}
            showLoad={true} loadText={""}
            showData={true} dataText={"Данные успешно получены!"}
            showError={true} errorText={""}
            showFail={true} failText={""}
          />
          {dataSalaryUser && (
            <div className="m-0 p-0">
              <div className="mb-3">
                <a
                  className="btn btn-primary"
                  href={`/${dataSalaryUser["excelPath"]}`}
                  style={{ borderRadius: 8, fontWeight: 600 }}
                >
                  <i className="fa-solid fa-file-excel m-0 p-1" />
                  Скачать Excel
                </a>
              </div>

              {/* Краткая информация */}
              <div className="custom-card m-0 p-0 mb-3" style={{ maxWidth: 560 }}>
                <div style={{ padding: "14px 18px", borderBottom: "1px solid var(--km-line)", fontWeight: 700, fontSize: 14 }}>
                  <i className="fa-solid fa-credit-card m-0 p-1" style={{ color: "var(--km-blue)" }} />
                  Краткая информация
                </div>
                <table className="table table-sm table-hover m-0">
                  <thead>
                    <tr>
                      <th className="text-start p-2 w-50">Тип</th>
                      <th className="text-end p-2">Значение</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataSalaryUser["headers"].slice(-2).map((head, index) => (
                      <tr key={index}>
                        <td className="text-start p-2">
                          {index === 1 ? "Выплата за текущий месяц" : "Выплата за предыдущий месяц"}
                        </td>
                        <td className={index === 1
                          ? "text-end fw-bold text-success p-2"
                          : "text-end p-2"}>
                          {head[1]}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Подробная информация */}
              <components.AccordionComponent
                key_target={"accordion1"}
                isCollapse={false}
                title={"Подробная информация"}
                text_style="text-primary"
                header_style="bg-primary bg-opacity-10 custom-background-transparent-low"
                body_style="bg-light bg-opacity-10 custom-background-transparent-low"
              >
                <div className="m-0 p-2">
                  <div className="custom-card m-0 p-0 mb-3" style={{ maxWidth: 560 }}>
                    <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--km-line)", fontWeight: 700, fontSize: 13 }}>
                      Вспомогательная информация
                    </div>
                    <table className="table table-sm table-striped table-hover m-0">
                      <thead>
                        <tr>
                          <th className="text-start p-2 w-50">Тип</th>
                          <th className="text-end p-2">Значение</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSalaryUser["headers"].slice(5, -2).map((head, index) => (
                          <tr key={index}>
                            <td className="text-start p-2">{head[0]}</td>
                            <td className="text-end p-2">{head[1]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <ul className="row row-cols-1 row-cols-lg-2 m-0 p-0 list-unstyled" style={{ "--bs-gutter-x": "1rem" }}>
                    {dataSalaryUser["tables"].map((tab, index) => (
                      <components.SalaryTableComponent key={index} tab={tab} />
                    ))}
                  </ul>
                  <div className="m-0 p-0 mt-2">
                    <div className="custom-card m-0 p-0">
                      <div style={{ padding: "12px 16px", borderBottom: "1px solid var(--km-line)", fontWeight: 700, fontSize: 13 }}>
                        Основная информация
                      </div>
                      <table className="table table-sm table-hover m-0">
                        <thead>
                          <tr>
                            <th className="text-start p-2 w-50">Тип</th>
                            <th className="text-end p-2">Значение</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataSalaryUser["headers"].slice(-2).map((head, index) => (
                            <tr key={index}>
                              <td className="text-start p-2">{head[0]}</td>
                              <td className={index === 1
                                ? "text-end fw-bold text-success p-2"
                                : "text-end p-2"}>
                                {head[1]}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </components.AccordionComponent>
            </div>
          )}
        </div>
      </main>
      <components.FooterComponent />
    </div>
  );
};
